import * as React from 'react';
import {Link} from 'react-router-dom';

import {PeepTwoLine} from 'shells/peep/peep-two-line';

import type {
    AccountSearchResult as AccountSearchResultFragment,
    ContactSearchResult as ContactSearchResultFragment,
} from 'nutshell-graphql-types';

import styles from './search-results.module.css';

type Props = {
    peep: AccountSearchResultFragment | ContactSearchResultFragment;
    isActive: boolean;
    closeSidebar: () => void;
};

export class SearchResultPeep extends React.PureComponent<Props> {
    render() {
        const secondaryInfo = this.secondaryInfo();

        return (
            // @ts-expect-error
            <Link
                to={this.props.peep.htmlUrlPath}
                onClick={this.props.closeSidebar}
                className={
                    this.props.isActive
                        ? styles['search-result--fake-focus']
                        : styles['search-result']
                }
            >
                <PeepTwoLine
                    name={this.props.peep.name}
                    avatarUrl={this.props.peep.avatarUrl}
                    initials={this.props.peep.initials}
                    type={this.props.peep.type}
                    htmlUrl={this.props.peep.htmlUrlPath}
                    isLinkable={false}
                    relatedEntityName={this.relatedEntityName()}
                />
                {secondaryInfo ? (
                    <div className={styles['secondary-info']}>{secondaryInfo}</div>
                ) : undefined}
            </Link>
        );
    }

    relatedEntityName = (): string | null | undefined => {
        if (this.props.peep.__typename === 'Account' && this.props.peep.primaryContact) {
            return this.props.peep.primaryContact.name;
        }

        if (this.props.peep.__typename === 'Contact' && this.props.peep.accounts) {
            return this.props.peep.accounts.primary
                ? this.props.peep.accounts.primary.name
                : undefined;
        }
    };

    secondaryInfo = (): string | null | undefined => {
        if (this.props.peep.__typename === 'Account') {
            const primaryAddress =
                this.props.peep.postalAddresses &&
                this.props.peep.postalAddresses.primary &&
                this.props.peep.postalAddresses.primary.value;

            // If we've got an address, use that
            if (primaryAddress) {
                if (primaryAddress.city && primaryAddress.postalCode) {
                    return `${primaryAddress.city}, ${primaryAddress.postalCode}`;
                } else if (primaryAddress.city) {
                    return primaryAddress.city;
                } else {
                    return primaryAddress.postalCode;
                }
            }

            // Next, try a phone number
            return this.props.peep.phones.primary
                ? this.props.peep.phones.primary.value.numberFormatted
                : undefined;
        }

        if (this.props.peep.__typename === 'Contact') {
            const primaryEmailAddress =
                this.props.peep.emailAddresses && this.props.peep.emailAddresses.primary
                    ? this.props.peep.emailAddresses.primary.value.address
                    : null;

            const primaryPhoneNumber = this.props.peep.phones.primary
                ? this.props.peep.phones.primary.value.numberFormatted
                : null;

            return primaryEmailAddress ? primaryEmailAddress : primaryPhoneNumber;
        }
    };
}
